import {
  CommunityMember,
  CommunityMemberWithLastTimesheet,
} from "graphql/client_app/types";
import React, { useMemo, useState } from "react";
import {
  MdThumbDown,
  MdThumbUp,
  MdOutlineThumbDownAlt,
  MdOutlineThumbUpAlt,
} from "react-icons/md";
import Modal from "react-modal";

import { CommunityMemberAvatar } from "@/client_app/components/CommunityMemberAvatar";
import {
  FeedbackItem,
  FeedbackParams,
} from "@/client_app/features/timesheetApproval/components/FeedbackItem";
import { sendRatingFeedBack } from "@/client_app/features/timesheetApproval/components/services/FetchAPIService";

Modal.setAppElement("body");
interface Props {
  members: (CommunityMember & CommunityMemberWithLastTimesheet)[];
  closeModal: () => void;
}
export const MultiFeedbackModal = ({
  members,
  closeModal,
}: Props): JSX.Element => {
  const [feedbackData, setFeedbackData] = useState({});
  const customStyles = {
    overlay: {
      zIndex: 9999,
      backgroundColor: "rgba(9, 32, 36, 0.9)",
    },
    content: {
      background: "none",
      border: "none",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      padding: "0",
    },
  };

  const handleOnChange = (value: FeedbackParams, positionId: string) => {
    setFeedbackData({ ...feedbackData, [positionId]: value });
  };

  const submitFeedback = () => {
    Object.values(feedbackData).forEach((data: FeedbackParams) => {
      sendRatingFeedBack(data).then();
    });
    closeModal();
  };

  return (
    <Modal isOpen={true} contentLabel='Feedback Modal' style={customStyles}>
      <div className='animated fadeIn fixed inset-0 overflow-y-auto flex items-center justify-center'>
        <div className='max-h-screen w-full max-w-lg relative'>
          <div className='bg-legacyColor-secondary-50 rounded-3xl border border-legacyColor-neutral-2-500 p-4 mx-auto max-w-md text-center'>
            <div className='overflow-y-auto max-h-[80vh]'>
              {members.map((member, index) => (
                <div className={`p-8 ${index > 0 ? "border-t" : ""}`}>
                  <FeedbackItem
                    positionId={member.positionId}
                    profileImageUrl={member.profileImageUrl}
                    fullName={member.fullName}
                    onChange={(value) => {
                      handleOnChange(value, member.positionId);
                    }}
                  />
                </div>
              ))}
            </div>

            <div className='flex justify-between w-full pt-2'>
              <button className='btn btn-sm btn-secondary' onClick={closeModal}>
                CANCEL
              </button>
              <button
                className='btn btn-sm btn-primary'
                onClick={submitFeedback}
                disabled={Object.keys(feedbackData).length === 0}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
